import React from "react";
import CheckoutContext from "../../checkout-context";
import iDeal from "../payment/payment-icons/ideal";
import Mollie from "../payment/payment-icons/mollie";
import { getDateToDigits } from "../../../../assets/js/date-time-converter";

class Input extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isTouched: false,
      passWordVisible: false,
    };
  }

  static contextType = CheckoutContext;

  componentDidMount() {
    if (this.props.inputType !== "radio") {
      this.checkInputFields();
    }
  }

  checkInputFields = () => {
    const { path, inputType, required, errorMessage, isDate } = this.props;

    const { getData, setData, updateFieldValidity } = this.context;

    if (isDate) {
      const currentDateValue = getData(path);

      if (currentDateValue !== "" && currentDateValue) {
        let dateDigitsValue = getDateToDigits(currentDateValue, true, false);
        // IE11 fix for Left-To-Right marks https://stackoverflow.com/questions/21413757/tolocaledatestring-changes-in-ie11
        dateDigitsValue = dateDigitsValue.replace(/\u200e/g, "");

        setData(path, dateDigitsValue);
      }
    }

    if (required) {
      let message;
      if (errorMessage === undefined) {
        message = this.props.resourcedTexts.inputErrorMessageDefault;
      } else {
        message = errorMessage;
      }

      updateFieldValidity(path, inputType, Boolean(getData(path)), message);
    } else {
      updateFieldValidity(path, inputType, true);
    }
  };

  checkValidation = () => {
    this.setState({
      isTouched: true,
    });
  };

  togglePasswordVisibility = (e) => {
    e.preventDefault();

    this.setState({
      passWordVisible: this.state.passWordVisible === false,
    });
  };

  renderInputDefault = () => {
    const {
      autoComplete,
      inputLabel,
      inputType,
      placeHolder,
      required,
      errorMessage,
      onBlurFunction,
      path,
      maxLength,
      allowNumbersOnly,
      resourcedTexts,
    } = this.props;

    const { getData, setData, errors, updateFieldValidity } = this.context;

    const mySetData = (path, value) => {
      setData(path, value);

      if (required) {
        updateFieldValidity(
          path,
          inputType,
          !!getData(path),
          errorMessage === undefined
            ? resourcedTexts.inputErrorMessageDefault
            : errorMessage
        );
      } else {
        updateFieldValidity(path, inputType, true);
      }
    };

    function handleInputChange(e) {
      if (allowNumbersOnly) {
        const hasValue = Boolean(e.target.value);
        const hasOnlyNumbers = /^\d+$/.test(e.target.value);
        if (hasValue && !hasOnlyNumbers) return;
      }

      mySetData(path, e.target.value);
    }

    return (
      <div
        className={`form-field ${this.state.isTouched ? "is-touched" : ""} ${
          errors[path] ? "is-invalid" : ""
        }`}
      >
        <label htmlFor={path}>{inputLabel}</label>
        <input
          type={
            inputType === "password" && this.state.passWordVisible
              ? "text"
              : inputType
          }
          placeholder={placeHolder}
          value={getData(path)}
          id={path}
          autoComplete={autoComplete}
          onChange={handleInputChange}
          maxLength={maxLength}
          onBlur={() => {
            this.checkValidation();

            if (onBlurFunction) {
              onBlurFunction(path);
            }
          }}
        />
        {inputType === "password" ? (
          <a
            href="#"
            className="toggle-password-visibility"
            onClick={(e) => this.togglePasswordVisibility(e)}
          >
            <span className="visually-hidden">Toon/verberg wachtwoord</span>
          </a>
        ) : null}
        <span className={`field-validation-error`}>{errors[path]}</span>
      </div>
    );
  };

  renderLabelRadioDefault = (radioButton) => {
    return (
      <label htmlFor={this.props.radioGroupName + "_" + radioButton.name}>
        {radioButton.name}
      </label>
    );
  };

  renderLabelPaymentMethod = (radioButton) => {
    switch (radioButton.value) {
      case "ideal":
        return (
          <label
            htmlFor={this.props.radioGroupName + "_" + radioButton.name}
            className="payment-method"
          >
            <div className="payment-method__wrap">
              <div className="payment-method__text">
                <strong>{radioButton.name}</strong>
                <p>{this.props.resourcedTexts.paymentMethodIdealDescription}</p>
              </div>
              <div className="payment-method__image">
                {Mollie()} {iDeal()}
              </div>
            </div>
          </label>
        );
      case "invoice":
        return (
          <label
            htmlFor={this.props.radioGroupName + "_" + radioButton.name}
            className="payment-method"
          >
            <div className="payment-method__wrap">
              <div className="payment-method__text">
                <strong>{radioButton.name}</strong>
                <p>
                  {this.props.resourcedTexts.paymentMethodInvoiceDescription}
                </p>
              </div>
            </div>
          </label>
        );
      default:
        return;
    }
  };

  renderInputRadio = (radioButton) => {
    const { inputType, onChangeFunction, path, defaultValue } = this.props;

    const { getData, setData, updateFieldValidity } = this.context;

    const mySetData = (path, value) => {
      setData(path, value);
      updateFieldValidity(path, inputType, true);
    };

    if (
      (getData(path) == null || getData(path)) === "" &&
      defaultValue != null
    ) {
      mySetData(path, defaultValue);
    }

    return (
      <div className="radio-group" key={radioButton.name}>
        <input
          id={this.props.radioGroupName + "_" + radioButton.name}
          type="radio"
          name={this.props.radioGroupName}
          defaultChecked={getData(this.props.path) === radioButton.value}
          disabled={
            radioButton.value === "ideal" && !this.props.directPaymentAvailable
          }
          onChange={(e) => {
            mySetData(this.props.path, radioButton.value);

            if (onChangeFunction) {
              onChangeFunction(this.props.path);
            }
          }}
        />

        {this.props.radioGroupName === "paymentMethods"
          ? this.renderLabelPaymentMethod(radioButton)
          : this.renderLabelRadioDefault(radioButton)}
      </div>
    );
  };

  render() {
    return (
      <React.Fragment>
        {this.props.inputType === "radio" ? (
          this.props.radioButtons.map((radioButton, i) => (
            <div
              className={`form-field-wrapper ${
                this.props.classNames !== undefined ? this.props.classNames : ""
              }`}
              key={i}
            >
              <div className="form-field">
                {this.renderInputRadio(radioButton)}
              </div>
            </div>
          ))
        ) : (
          <div
            className={`form-field-wrapper ${
              this.props.classNames !== undefined ? this.props.classNames : ""
            }`}
          >
            {this.renderInputDefault()}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export { Input };
